import { createAsyncSlice } from '../../../../createAsyncSlice';
import { sendInternalTransferAsync } from '../../../../../API/order/escrow/EscrowAPI';

export const { slice: sendInternalTransferSlice, asyncAction: sendInternalTransferAction } = createAsyncSlice(
  'sendInternalTransferSlice',
  sendInternalTransferAsync
);
